module.exports = __webpack_public_path__ + "static/media/link-button.cb09e273.png";